import React, { FC } from 'react';
import Tooltip from 'rc-tooltip';
import { isEmpty } from 'lodash';
import { useMedia } from 'react-use';

interface ITooltipComponent {
  step: any;
  completed: any;
  active: any;
  children: any;
  renderPillContent: any;
}

type Props = ITooltipComponent;

const TooltipComponent: FC<Props> = ({ step, completed, children, renderPillContent }) => {
  const isMobile = useMedia('(max-width: 768px)');
  const renderOptions = renderPillContent(step, null, null);
  const { hasContent, content } = renderOptions;
  const isExist =
    typeof hasContent === 'object' ? !isEmpty(hasContent) : hasContent !== null && hasContent !== undefined;
  const isEmptyContent =
    typeof content === 'object'
      ? Array.isArray(content)
        ? isEmpty(Array.from(content)?.flat() || [])
        : isEmpty(content)
      : !!content;

  return (
    <Tooltip
      overlayClassName='progress-bar-tooltips'
      overlay={
        completed &&
        renderOptions &&
        !isEmptyContent &&
        content &&
        isExist && (
          <div className='tooltip-wrapper'>
            <ul>{content}</ul>
          </div>
        )
      }
      placement='bottom'
    >
      {children}
    </Tooltip>
  );
};

export default TooltipComponent;
